import { Box } from "@mui/material";
import useTheme from "../hooks/useTheme";
import styled from "@emotion/styled";

const Brand = styled(Box)<{
  component?: React.ReactNode;
  to?: string;
}>`
  font-size: ${(props: any) => props.theme.typography.h5.fontSize};
  font-weight: ${(props: any) => props.theme.typography.fontWeightMedium};
  color: ${(props: any) => props.theme.sidebar.header.color};
  //   background-color: ${(props: any) =>
    props.theme.sidebar.header.background};
  font-family: ${(props: any) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props: any) => props.theme.spacing(6)};
  padding-right: ${(props: any) => props.theme.spacing(6)};
  justify-content: center;
  //   cursor: pointer;
  flex-grow: 0;
  align-items: center;
  display: flex;

  ${(props: any) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  //   &:hover {
  //     background-color: ${(props: any) =>
    props.theme.sidebar.header.background};
  //   }
`;

const GoBeyondLogo = (props: any) => {
  const { theme } = useTheme();

  return (
    <Brand>
      <img
        src="/static/img/logo/horizontal_logo.svg"
        style={{
          maxHeight: "36px",
        }}
      />
    </Brand>
  );
};

export default GoBeyondLogo;
